import { Store } from "../index.js";
import { useUnmount } from "../../react/hooks/index.js";
import { useMemo, useRef, useState } from "react";

//#region src/module/store/react/index.ts
function useStore(store, stateSelector) {
	const [state, setState] = useState(store.getState(stateSelector));
	const isMounted = useRef(true);
	const unsub = useMemo(() => {
		return store.subscribe(stateSelector, (nextState) => {
			if (!isMounted.current) return;
			setState(() => nextState);
		});
	}, []);
	useUnmount(() => {
		isMounted.current = false;
		unsub();
	});
	return state;
}
var Store$1 = class extends Store {
	constructor(...args) {
		super(...args);
		this.useState = this.useState.bind(this);
	}
	useState(stateSelector) {
		return useStore(this, stateSelector);
	}
};

//#endregion
export { Store$1 as Store, useStore };